import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/toaster";
import { EnquiryProvider } from "./context/EnquiryContext";
import EnquiryModal from "./components/EnquiryModal";
import EnquireFab from "./components/EnquireFab";

import * as V1 from "./versions/v1"; // Premium Medical (only active design)

function Site() {
  const { Navbar, Footer, Home, About, TMS, Fees, News, Contact, AcceleratedTMS, Esketamine, FAQ, Team, TeamMember } = V1;
  return (
    <div className="min-h-screen">
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/about/team" element={<Team />} />
          <Route path="/about/team/:slug" element={<TeamMember />} />
          <Route path="/tms" element={<TMS />} />
          <Route path="/accelerated-tms" element={<AcceleratedTMS />} />
          <Route path="/esketamine" element={<Esketamine />} />
          <Route path="/fees" element={<Fees />} />
          <Route path="/news" element={<News />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <EnquiryProvider>
          <Site />
          <EnquiryModal />
          <EnquireFab />
        </EnquiryProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
